import qs from 'querystring';
import { get } from 'lodash';
import PLAYER_TYPES from 'constants/player-types';

export const getAuthorizedEndpointUrl = (url, isLoggedIn) => (isLoggedIn ? url.replace('/public', '') : url);

export const resolvePlayerNavLink = (item, { type, query, timeshiftBegin, isVodChannel } = {}) => {
  let url = '';
  let playerType = '';

  const { id, metadata, epgEvent, userVodAssetUrl, seasonIds } = item;

  if (type) {
    playerType = type;
  } else if (seasonIds || metadata?.contentType === 'EPISODE') {
    playerType = PLAYER_TYPES.SERIES;
  } else {
    playerType = PLAYER_TYPES.VOD;
  }

  if (playerType === PLAYER_TYPES.CHANNEL) {
    if (isVodChannel) {
      const { currentProgram } = item;
      // Empty string is a valid param
      const startTime = metadata?.startTime || currentProgram?.startTime || '';

      url = `/player/vod-channel/${id}/${startTime}`;
    } else if (metadata && metadata.startTime) {
      url = `/player/channel/${id}/${metadata.startTime}`;
    } else if (epgEvent) {
      let type = 'channel';
      if (epgEvent?.channel?.isVod) type = 'vod-channel';

      url = `/player/${type}/${get(epgEvent.channel, ['id'])}/${epgEvent.startTime}`;
    } else {
      // Only for plain channel player
      if (timeshiftBegin) query = Object.assign({}, query, { timeshiftBegin });
      url = `/player/channel/${id}`;
    }
  } else if (playerType === PLAYER_TYPES.VOD) {
    url = `/player/vod/${id}`;
  } else if (playerType === PLAYER_TYPES.SERIES) {
    if (userVodAssetUrl) {
      const lastWatchedEpisodeID = userVodAssetUrl.split('/').pop();
      url = `/player/series/${id}/${lastWatchedEpisodeID}`;
    } else if (metadata && metadata.contentType === 'EPISODE') {
      url = `/player/series/${metadata.tvSeriesId}/${id}`;
    } else {
      url = `/player/series/${id}`;
    }
  } else if (playerType === PLAYER_TYPES.TRAILER) {
    url = `/player/trailer/${id}`;
  }

  if (query) url += `?${qs.stringify(query)}`;

  return url;
};

export default {
  getAuthorizedEndpointUrl,
};
